import React from 'react';
import { Modal } from 'library/ui';

import { AdditionalQualificationsSection } from './AdditionalQualificationsSection';

import type { IManagedScale } from '../types';

export function AdditionalModal({
    open,
    onClose,
    scale,
}: {
    open: boolean;
    onClose: () => void;
    scale: IManagedScale;
}) {
    if (!open) {
        return null;
    }

    return (
        <Modal title="Add Additional Qualifications" onClose={onClose}>
            <AdditionalQualificationsSection scale={scale} />
        </Modal>
    );
}
